import { Link, Span } from "@vp/swan";
import React from "react";
import { useLocalization } from "../../hooks/useLocalizations";

const NO_VAT_LOCALES = new Set([
  "en-us",
  "en-ca",
  "en-au",
  "en-in",
  "en-sg",
  "en-nz",
  "en-jp",
  "ja-jp",
  "es-us",
  "fr-ca",
]);

const DE_DE_SHIPPING_PATH = "/lieferung";

interface VatMessageProps {
  locale: string;
  vatInc: boolean;
  hideShippingMessageInVatMessage?: boolean;
  className?: string;
}

const VatMessage: React.FC<VatMessageProps> = ({
  locale,
  vatInc,
  hideShippingMessageInVatMessage,
  className,
}) => {
  const { t } = useLocalization();
  const normalizedLocale = locale.toLowerCase();

  if (NO_VAT_LOCALES.has(normalizedLocale)) {
    return null;
  }

  const showShippingLink = normalizedLocale === "de-de" && !hideShippingMessageInVatMessage;

  const SpanClass = ["swan-short-tax-message", className].filter(Boolean).join(" ");

  if (showShippingLink) {
    const vatWithShippingKey = vatInc
      ? "price-platform.token-price.vat-inc-with-shipping"
      : "price-platform.token-price.vat-ex-with-shipping";
    const shippingLinkText = t("price-platform.token-price.shipping-message");
    return (
      <Span className={SpanClass}>
        {t(vatWithShippingKey, {
          shippingMessage: (
            <Link key="shipping-link" target="_blank" href={DE_DE_SHIPPING_PATH} rel="noopener noreferrer">
              {shippingLinkText}
            </Link>
          ),
        })}
      </Span>
    );
  }

  const vatKey = vatInc
    ? "price-platform.token-price.vat-inc"
    : "price-platform.token-price.vat-ex";

  return <Span className={SpanClass}>{t(vatKey)}</Span>;
};

export default VatMessage;
